var map = {
	"./image/description_image_1.jpg": 662,
	"./image/description_image_2.jpg": 925,
	"./image/testimonial_image_1.jpg": 59,
	"./image/testimonial_image_12.jpg": 371,
	"./image/testimonial_image_13.jpg": 781,
	"./image/testimonial_image_14.jpg": 633,
	"./image/testimonial_image_15.jpg": 560,
	"./image/testimonial_image_16.jpg": 624,
	"./image/testimonial_image_17.jpg": 454,
	"./image/testimonial_image_18.jpg": 138,
	"./image/testimonial_image_19.jpg": 522,
	"./image/testimonial_image_2.jpg": 193,
	"./image/testimonial_image_20.jpg": 853,
	"./image/testimonial_image_21.jpg": 994,
	"./image/testimonial_image_4.jpg": 507,
	"./image/testimonial_image_5.jpg": 383,
	"./image/testimonial_image_6.jpg": 306,
	"./image/testimonial_image_7.jpg": 746,
	"./image/testimonial_image_8.jpg": 177,
	"./image/testimonial_image_9.jpg": 216,
	"./video/testimonial_image_3.mp4": 280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 945;